import type { ReactNode } from "react";
import { useIsNavigationFocused } from "@-/dev.improve.haniverse.contexts.primary-controls-strip.opaque-chrome";
import {
  RouteBodyRetentionProvider,
  RouteBodyStateProvider,
  useRouteBodyCanRelease,
} from "@-/dev.improve.haniverse.lib.navigation.route-body-state";

function FocusedStatsBody({ children }: { children: ReactNode }) {
  const focused = useIsNavigationFocused();
  const canRelease = useRouteBodyCanRelease();
  return focused || !canRelease ? children : null;
}

/** Keep route state and an explicitly open sheet; retire hidden queries, charts and views. */
export function LearningStatsRouteBody({ children }: { children: ReactNode }) {
  return (
    <RouteBodyStateProvider>
      <RouteBodyRetentionProvider>
        <FocusedStatsBody>{children}</FocusedStatsBody>
      </RouteBodyRetentionProvider>
    </RouteBodyStateProvider>
  );
}
